import React from "react";

function IotSecurity() {
  return (
    <div>
      <div class="Thumbnail"></div>
      <div class="ThumbnailMargin"></div>

      <div class="contentAfter col-md-10 mt-5 mb-5 p-2 ms-auto me-auto">
        <div class="text-center mb-5 w-full mx-auto">
          <span class="text-hollow text-transparent">
            IOT Security Assessment
          </span>
        </div>
        <p>
          Internet of Thing security assessment is a security audit used for
          identifying potential risks that may prove to be problematic in the
          future. It helps in eliminating those risks in the beginning before
          becoming a real problem.
        </p>
        <p>
          Sub-services we offer in the IoT Security Assessment are IoT device
          penetration testing, medical device penetration testing, ATM
          penetration testing, and drone penetration testing.
        </p>
        <div class="row">
          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">
                  Smart-device/ IoT device penetration testing
                </h5>
                <div class="card-text mt-3 mb-3">
                  Smart-device/IoT device pentest is the penetration test on
                  various factors of IoT devices like hardware, implanted
                  software, servers, and APIs. It maximizes the security system
                  with the help of a comprehensive report formed by it.
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">Medical device penetration testing</h5>
                <div class="card-text mt-3 mb-3">
                  <p>
                    Medical devices pentest critically assesses all the
                    appliances and systems involved in the healthcare sector. It
                    identifies the vulnerabilities and flaws present in the
                    concerned equipment, devices, hardware, and software used
                    for treating patients or storing their sensitive data.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">ATM penetration testing</h5>
                <div class="card-text mt-3 mb-3">
                  <p>
                    ATM penetration testing technique is used for checking the
                    efficiency of the ATM system at present and for discovering
                    the points that need improvement, providing better and more
                    secure ATM service. It reduces the chances as well as data
                    thefts at ATMs.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">Drone penetration testing</h5>
                <div class="card-text mt-3 mb-3">
                  <p>
                    Drones usage is spreading like wildfire, and so are the
                    cybercrimes revolving around it. It has become essential to
                    focus on drone security to sustain the effectiveness of
                    drones and their controllers.
                  </p>
                  <p>
                    Secure your drone now to save yourself from cleaning a big
                    dirty mess by an unwanted guest later as/Rise fearlessly now
                    with drone penetration test because-
                  </p>
                  <ol className="mt-3">
                    <li>
                      It analyses he security systems and the possible gaps in
                      the system.
                    </li>
                    <li>
                      It ensures that the drones don't suffer from any
                      unforeseen downtime.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IotSecurity;
